import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../Auths/CheckUser.js";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

const AirClientList = () => {
    const { user } = useAuth();
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);

    useEffect(() => {
        if (!user) return;

        const fetchUser = async () => {
            try {
                const res = await axios.get(`https://globizsystems.click/api/user/${user.id}`);
                // console.log("Fetched user:", res.data);

                // Set clients safely
                setClients(Array.isArray(res.data.airclients) ? res.data.airclients : []);
            } catch (error) {
                console.error(error);
                Swal.fire("Error", "Failed to load user data", "error");
            }
        };

        fetchUser();
    }, [user]);

    const handleClientClick = (client) => {
        setSelectedClient(client);
    };

    const closePopup = () => {
        setSelectedClient(null);
    };

    return (
        <div className="mt-4">
            <h2 className="text-xl font-bold mb-4">Clients : {clients.length || 0}</h2>

            {clients.length === 0 ? (
                <p className="text-gray-500">No clients assigned.</p>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {clients.map((client) => (
                        <div
                            key={client.id}
                            onClick={() => handleClientClick(client)}
                            className="p-4 border rounded-lg shadow-sm cursor-pointer hover:bg-gray-100"
                        >
                            <p className="font-semibold">
                                <span>{client.id}:</span> {client.name}
                            </p>
                            <p className="text-sm text-gray-600">Account No: {client.accountNumber}</p>
                            <p className="text-sm text-gray-600">Status: {client.status}</p>
                        </div>
                    ))}
                </div>
            )}

            {/* Popup for client details */}
            {selectedClient && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-[450px] max-h-[90vh] overflow-y-auto">
                        <div className="flex items-center justify-between">
                            <h3 className="text-lg font-bold mb-3">{selectedClient.name}</h3>
                            <button onClick={closePopup}>
                                <FontAwesomeIcon icon={faClose} />
                            </button>
                        </div>
                        <div className="text-sm space-y-1">
                            <p><strong>ID:</strong> {selectedClient.id}</p>
                            <p><strong>Account Number:</strong> {selectedClient.accountNumber}</p>
                            <p><strong>Name:</strong> {selectedClient.name}</p>
                            <p><strong>Area Code:</strong> {selectedClient.areaCode}</p>
                            <p><strong>Area Name:</strong> {selectedClient.areaName}</p>
                            <p><strong>Unit Number:</strong> {selectedClient.unitNumber}</p>
                            <p><strong>Account No:</strong> {selectedClient.accountNo}</p>
                            <p><strong>Unit Address:</strong> {selectedClient.unitAddress}</p>
                            <p><strong>Payment Amount:</strong> RM {(Number(selectedClient.paymentAmount) || 0).toLocaleString()}</p>
                            <p><strong>Arrears:</strong> RM {(Number(selectedClient.arrears) || 0).toLocaleString()}</p>
                            <p><strong>Collection Center:</strong> {selectedClient.collectionCenter}</p>
                            <p><strong>Receipt Number:</strong> {selectedClient.receiptNumber}</p>
                            <p><strong>Receipt Date:</strong> {new Date(selectedClient.receiptDate).toLocaleString()}</p>
                            <p><strong>Status:</strong> {selectedClient.status}</p>
                            <p><strong>Contract Type:</strong> {selectedClient.contractType}</p>
                            <p><strong>Contract Start Date:</strong> {new Date(selectedClient.contractStartDate).toLocaleDateString()}</p>
                            <p><strong>Contract End Date:</strong> {new Date(selectedClient.contractEndDate).toLocaleDateString()}</p>
                            <p><strong>Created At:</strong> {new Date(selectedClient.createdAt).toLocaleString()}</p>
                            <p><strong>Updated At:</strong> {new Date(selectedClient.updatedAt).toLocaleString()}</p>

                            {selectedClient.contractImage && (
                                <div className="mt-2">
                                    <strong>Contract Image:</strong>
                                    <img
                                        src={selectedClient.contractImage}
                                        alt="Contract"
                                        className="mt-1 rounded-lg border w-60"
                                    />
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
};

export default AirClientList;
